/**
 *
 * FormIndicator
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import {
  makeSelectForm,
  makeSelectIsLoadingForm,
  makeSelectLoadingSave,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import "./index.less"
import TabsComponents from "./Components/Tabs"
import {
  getShowOtherIndicatorWatcher,
  getUpdateOtherIndicatorWatcher,
} from "./actions"

/* eslint-disable react/prefer-stateless-function */
export class FormIndicator extends React.Component {
  componentDidMount() {
    const { showOtherIndicator, match } = this.props
    const { id } = match.params
    showOtherIndicator({ id })
  }

  returnIndicators = () => {
    const { history } = this.props
    history.push(`control-panel#other-indicators`)
  }

  render() {
    const { form } = this.props
    return (
      <div className="form-indicator-container">
        <div className="container-controlpanel__right-title">
          <a onClick={() => this.returnIndicators()}>{"< Indicadores"}</a>
        </div>
        <div className="container-controlpanel__right-content container-height">
          <div className="container-custom-indicators">
            <div className="table-indicators container-name-indicator">
              {form.survey_type_name || ""}
            </div>
            <TabsComponents {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

FormIndicator.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoadingForm: makeSelectIsLoadingForm(),
  form: makeSelectForm(),
  isLoadingSave: makeSelectLoadingSave(),
})

function mapDispatchToProps(dispatch) {
  return {
    showOtherIndicator: (params) =>
      dispatch(getShowOtherIndicatorWatcher(params)),
    updateOtherIndicator: (params) =>
      dispatch(getUpdateOtherIndicatorWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "formIndicator", reducer })
const withSaga = injectSaga({ key: "formIndicator", saga })

export default compose(withReducer, withSaga, withConnect)(FormIndicator)
